var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-card auction" },
    [
      _c(
        "div",
        {
          staticClass: "spaceLeft",
          staticStyle: { "align-items": "baseline" },
        },
        [
          _c("div", { staticClass: "detail-title-1" }, [_vm._v("My auction")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                color: "#DCE0E7",
                "font-size": "0.18rem",
                "margin-top": "0.2rem",
              },
            },
            [
              _vm._v(
                "Won/Participated: " +
                  _vm._s(_vm.info.auctionWinCount || 0) +
                  "/" +
                  _vm._s(_vm.info.auctionsCount || 0)
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 28 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
            _c("div", { staticClass: "common-card" }, [
              _c("div", { staticClass: "common-card-main" }, [
                _c("div", { staticClass: "flexStart" }, [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "spaceBetween",
                        staticStyle: {
                          "min-height": "0.44rem",
                          "margin-bottom": "0.44rem",
                        },
                      },
                      [
                        _c("div", { staticClass: "spaceLeft card-text-1" }, [
                          _c("div", { staticClass: "logo" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/image/exchange/TCashIcon.png"),
                              },
                            }),
                          ]),
                          _vm._v(
                            "\n                  TCash Spent\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        +_vm.info.auctionAmount > 0
                          ? _c(
                              "el-button",
                              {
                                staticStyle: {
                                  border: "0px",
                                  background:
                                    "linear-gradient( 90deg, #0E3491 0%, #225BFC 100%)",
                                },
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push(
                                      "/TCashFinance/auction/placeBid/record"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "iconfont trn-up" }),
                                _vm._v(" Withdraw TCash"),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-text-2" }, [
                      _c(
                        "span",
                        [
                          _c("big-number", {
                            attrs: { number: _vm.info.auctionAmount },
                            on: {
                              "update:number": function ($event) {
                                return _vm.$set(
                                  _vm.info,
                                  "auctionAmount",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
            _c("div", { staticClass: "common-card" }, [
              _c("div", { staticClass: "common-card-main" }, [
                _c("div", { staticClass: "flexStart" }, [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "spaceBetween",
                        staticStyle: {
                          "min-height": "0.44rem",
                          "margin-bottom": "0.44rem",
                        },
                      },
                      [
                        _c("div", { staticClass: "spaceLeft card-text-1" }, [
                          _c("div", { staticClass: "logo" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/image/exchange/unit.png"),
                              },
                            }),
                          ]),
                          _vm._v(
                            "\n                  UNIT Won\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        +_vm.info.auctionWinAmount > 0
                          ? _c(
                              "el-button",
                              {
                                staticStyle: {
                                  border: "0px",
                                  background:
                                    "linear-gradient( 90deg, #0E3491 0%, #225BFC 100%)",
                                },
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push(
                                      "/TCashFinance/auction/placeBid/record"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "iconfont trn-up" }),
                                _vm._v(" Withdraw winnings"),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-text-2" },
                      [
                        _c("big-number", {
                          attrs: { number: _vm.info.auctionWinAmount },
                          on: {
                            "update:number": function ($event) {
                              return _vm.$set(
                                _vm.info,
                                "auctionWinAmount",
                                $event
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }